import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=1129f521&"
import script from "./BaseNotification.vue?vue&type=script&lang=ts&"
export * from "./BaseNotification.vue?vue&type=script&lang=ts&"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports